/* Imports */
import React, { useState } from "react"
import { Font, Flexbox, Modal, Button, Alert, Image } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

import commonProps from "../../data/common-props"

const ModalPage = () => {
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isModalButtonOpen, setIsModalButtonOpen] = useState(false)
    const [isModalAlertOpen, setIsModalAlertOpen] = useState(false)

    const items = [
        {
            title: "Without close button",
            content: (
                <Flexbox>
                    <Button onClick={() => setIsModalOpen(true)}>Open modal</Button>

                    <Modal isOpen={isModalOpen} onClick={() => setIsModalOpen(false)}>
                        <Image src="/images/modal.jpg" alt="Modal" fit="contain" width="100%" height="100%" />
                    </Modal>
                </Flexbox>
            ),
            code: 'const [isModalOpen, setIsModalOpen] = useState(false)\n\n<Button onClick={() => setIsModalOpen(true)}>Open modal</Button>\n<Modal isOpen={isModalOpen} onClick={() => setIsModalOpen(false)}>\n    <Image src="/images/modal.jpg" alt="Modal" fit="contain" width="100%" height="100%" />\n</Modal>',
        },
        {
            title: "With close button",
            content: (
                <Flexbox>
                    <Button onClick={() => setIsModalButtonOpen(true)}>Open modal</Button>

                    <Modal isOpen={isModalButtonOpen} close={() => setIsModalButtonOpen(false)}>
                        <Image src="/images/modal.jpg" alt="Modal" fit="contain" width="100%" height="100%" />
                    </Modal>
                </Flexbox>
            ),
            code: 'const [isModalButtonOpen, setIsModalButtonOpen] = useState(false)\n\n<Button onClick={() => setIsModalButtonOpen(true)}>Open modal</Button>\n<Modal isOpen={isModalButtonOpen} close={() => setIsModalButtonOpen(false)}>\n    <Image src="/images/modal.jpg" alt="Modal" fit="contain" width="100%" height="100%" />\n</Modal>',
        },
        {
            title: "With an alert",
            content: (
                <Flexbox>
                    <Button onClick={() => setIsModalAlertOpen(true)}>Open modal</Button>

                    <Modal isOpen={isModalAlertOpen}>
                        <Alert color="danger" modal>
                            <Font.P>Modal content</Font.P>

                            <Flexbox align="center" gap="xs">
                                <Button color="danger">Button</Button>
                                <Button buttonStyle="text" onClick={() => setIsModalAlertOpen(false)}>
                                    Close
                                </Button>
                            </Flexbox>
                        </Alert>
                    </Modal>
                </Flexbox>
            ),
            code: 'const [isModalAlertOpen, setIsModalAlertOpen] = useState(false)\n\n<Button onClick={() => setIsModalAlertOpen(true)}>Open modal</Button>\n<Modal isOpen={isModalAlertOpen}>\n    <Alert color="danger" modal>\n        <Font.P>Modal content</Font.P>\n\n        <Flexbox align="center" gap="xs">\n            <Button color="danger">Button</Button>\n            <Button buttonStyle="text" onClick={() => setIsModalAlertOpen(false)}>\n                Close\n            </Button>\n        </Flexbox>\n    </Alert>\n</Modal>',
        },
    ]

    const propsItems = [
        {
            name: "isOpen",
            type: "Boolean",
            required: "Yes",
        },
        {
            name: "close",
            type: "Function",
            required: "Yes, if you want a close button",
        },
        {
            name: "iconClose",
            type: "String",
            example: "close-circle",
        },
        {
            name: "fajnyIconClose",
            type: "String",
            example: "close-circle-solid",
            possible: commonProps.fajnyIcons,
            default: "close-solid",
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default ModalPage
